"use strict";

(function processSharedWishlist() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const p = urlParams.get("p");
    if (p) {
      const decodedIds = p
        .split(/[,-]/)
        .map((code) => {
          const trimmed = code.trim();
          if (!trimmed) return null;
          const parsed = parseInt(trimmed, 36);
          return isNaN(parsed) ? null : parsed.toString();
        })
        .filter(Boolean);
      if (decodedIds.length > 0) {
        let existing = [];
        try {
          existing = JSON.parse(
            localStorage.getItem("glozin__wishlist-items") || "[]"
          );
        } catch (e) {
          existing = [];
        }
        if (!Array.isArray(existing)) existing = [];
        const merged = Array.from(new Set([...existing, ...decodedIds]));
        localStorage.setItem("glozin__wishlist-items", JSON.stringify(merged));
      }
    }
  } catch (err) {
    console.error("Error processing shared wishlist parameter:", err);
  }
})();

const wishlist_items = JSON.parse(
  localStorage.getItem("glozin__wishlist-items")
);
const wishlistDiv = document.querySelector(".wishlist-page-main");
var WishlistPageShopify = (function () {
  return {
    initWishlistItems: function () {
      if (window.location.search.indexOf("page=") == -1) {
        this.init();
      }
    },

    init: function () {
      const _this = this;
      if (wishlistDiv) {
        const div_no_product = wishlistDiv.querySelector(
          ".wishlist-no-product-js"
        );
        if (wishlist_items === null || wishlist_items.length === 0) {
          _this.skeletonFunction(0);
          if (div_no_product) div_no_product.classList.remove("hidden");
          _this.updateShareWishlist();
        } else {
          var query = "";
          wishlist_items.forEach((e, key, wishlist_items) => {
            if (!Object.is(wishlist_items.length - 1, key)) {
              query += e + "%20OR%20id:";
            } else {
              query += e;
            }
          });
          const section_id = document.querySelector(".wishlist-page-section")
            ?.dataset.sectionId;
          if (!section_id) return;
          var productAjaxURL =
            "?section_id=" +
            section_id +
            "&type=product&options[unavailable_products]=last&q=id:" +
            query;

          fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = parser.parseFromString(responseText, "text/html");
              const row = document.createElement("div");
              row.classList.add("wishlist-list-items");
              const exist_row = wishlistDiv.querySelector(
                ".wishlist-list-items"
              );
              if (exist_row) {
                exist_row.remove();
              }
              const er = html.querySelector(
                ".wishlist-page-main .wishlist-list-items"
              );
              if (wishlist_items.length !== 0 && er) {
                wishlistDiv.innerHTML = html.querySelector(
                  ".wishlist-page-main"
                ).innerHTML;
                _this.skeletonFunction(700);
              } else {
                _this.skeletonFunction(0);
                if (div_no_product) div_no_product.classList.remove("hidden");
              }
              _this.mergeItems();
              _this.bindShareEvent();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally((e) => {
              initLazyloadItem();
              _this.updateShareWishlist();
            });
        }
      }
    },
    bindShareEvent: function () {
      const shareBtn = document.querySelector(".share-wishlist-addon");
      if (shareBtn) {
        shareBtn.addEventListener("click", () => {
          this.updateShareWishlist();
        });
      }
      document.addEventListener("modal:opened", () => {
        this.updateShareWishlist();
      });
    },
    mergeItems: function () {
      const arr = [];
      if (wishlistDiv) {
        wishlistDiv
          .querySelectorAll(".product-item__action button-wishlist")
          .forEach((e) => {
            arr.push(e?.dataset.productId);
          });
      }
      localStorage.setItem("glozin__wishlist-items", JSON.stringify(arr));
      this.updateShareWishlist();
    },
    updateShareWishlist: function () {
      let items = [];
      try {
        items = JSON.parse(
          localStorage.getItem("glozin__wishlist-items") || "[]"
        );
      } catch (e) {
        items = [];
      }
      const shareWrapper = document.querySelector(".wishlist-share-wrapper");

      if (!items || !items.length) {
        if (shareWrapper) shareWrapper.style.display = "none";
        return;
      }
      if (shareWrapper) shareWrapper.style.display = "";

      const base36Codes = items
        .map((id) => {
          const num = Number(id);
          return isNaN(num) || num <= 0 ? null : num.toString(36);
        })
        .filter(Boolean);

      if (!base36Codes.length) return;

      const shareParam = base36Codes.join("-");
      const shareUrl = `${window.location.origin}${window.location.pathname}?p=${shareParam}`;

      document.querySelectorAll(".wishlist-share-url-text").forEach((el) => {
        el.textContent = shareUrl;
      });

      document.querySelectorAll(".wishlist-share-copy-btn").forEach((copyBtn) => {
        copyBtn.setAttribute("data-content", shareUrl);
        if (typeof copyBtn.updateUrl === "function") {
          copyBtn.updateUrl(shareUrl);
        }
        copyBtn.onclick = function (e) {
          e.preventDefault();
          if (navigator.clipboard) {
            navigator.clipboard.writeText(shareUrl);
            copyBtn.classList.add("copied");
          }
        };
      });

      document.querySelectorAll(".wishlist-share-wa").forEach((waBtn) => {
        waBtn.onclick = function (e) {
          e.preventDefault();
          window.open(
            `https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`,
            "whatsapp-share-dialog",
            "width=600,height=600"
          );
          return false;
        };
      });

      document.querySelectorAll(".wishlist-share-ig").forEach((igBtn) => {
        igBtn.onclick = function (e) {
          e.preventDefault();
          if (navigator.clipboard) {
            navigator.clipboard.writeText(shareUrl);
            const copyBtn = document.querySelector(".wishlist-share-copy-btn");
            if (copyBtn) copyBtn.click();
          }
          return false;
        };
      });

      document.querySelectorAll(".wishlist-share-email").forEach((emailBtn) => {
        emailBtn.onclick = function (e) {
          e.preventDefault();
          window.location.href = `mailto:?subject=${encodeURIComponent("Check out my wishlist")}&body=${encodeURIComponent(shareUrl)}`;
          return false;
        };
      });

      document.querySelectorAll(".wishlist-share-fb").forEach((fbBtn) => {
        fbBtn.onclick = function (e) {
          e.preventDefault();
          window.open(
            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
            "facebook-share-dialog",
            "width=436,height=436"
          );
          return false;
        };
      });
    },
    skeletonFunction: function (timer) {
      window.setTimeout(function () {
        if (this.document.querySelector("skeleton-page")) {
          this.document.querySelector("skeleton-page").remove();
        }
        if (this.document.querySelector(".wishlist-page-section-inner")) {
          this.document
            .querySelector(".wishlist-page-section-inner")
            .classList.remove("hidden");
        }
      }, timer);
    },
  };
})();
WishlistPageShopify.initWishlistItems();
